module.exports = __webpack_public_path__ + "static/media/nuk-pro-buildings.7e32888c.png";